import { PatientCommandParams } from './PatientCommandParams';
import { Command } from './Command';
import { NCZIExtension, NCZIReference } from '../Interfaces/ncziTypes';

type DiagnosisItem = {
  diagnosis: NCZIReference
  isMain: boolean
  specification: string | undefined
  lifeAffecting: boolean
}

export type WritePatientExaminationResultParams = PatientCommandParams & {
  type: string
  examination: {
    createdAt: string
    sentAt?: string | undefined
    requestForExamination?: NCZIExtension | undefined,
    sender?: {
      nonContractualHealthProfessional: boolean
      healthServiceProvider: NCZIExtension
      healthProfessional: NCZIExtension
      specialization: NCZIReference
    } | undefined
    dispensary: boolean
    examinationTime: string
    requestTicketOnly: boolean
    descriptionText: string
    versionStatus: string
    examinationTitle: string | undefined
    anamnesis: string | undefined
    internalNote: string | undefined
    medication: string | undefined
    expectedDateOfBirth: string | undefined
    allergen: {
      substance: NCZIReference
      medicinal: NCZIReference
    } | undefined
    implantedMedicalDevice: {
      description: string
      type: NCZIReference
    } | undefined
    sensitivity: number
    uncertaintyExpressed: boolean
    nonContractualHealthProfessional: boolean
    examinationUrgency: NCZIReference
    diagnosis: DiagnosisItem[]
    recommendation?: string | undefined
    recommendationForExamination: {
      type: NCZIReference
      professionalFocus: NCZIReference
      examinedBodyPart: NCZIReference | undefined
      modalityOfImagingExamination: NCZIReference | undefined
      requiredExamination: string
      diagnosis: NCZIReference[]
      urgency: NCZIReference
      patientInfo: string | undefined
      sedationNeed: boolean
      extract: {
        medicalRecords: NCZIExtension[]
      } | undefined
    } | undefined
  }
};

export const WritePatientExaminationResult = (params: WritePatientExaminationResultParams): Command => {
  return {
    operation: 'ZapisZaznamOVysetreni_v7',
    params
  };
};